class ChoicesSelect extends HTMLElement {
    constructor() {
        super()

        this.select = this.querySelector('select')

        this.choices = new Choices(this.select, {
            searchEnabled: false,
            itemSelectText: '',
            removeItemButton: false,

        })

        this.select.addEventListener('change', () => {
            this.select.dispatchEvent(new Event('input', { bubbles: true }))
        })
    }
}

customElements.define('choices-select', ChoicesSelect)
